import React, { useState, useEffect } from "react";
import { AssessmentTemplate } from "./assessment-templete";
import { faHouse } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { headerConfig } from "../../../axiosconfig.js";
import { SUMMARY_FIELDS } from "../../../pearliCore/assessment";

const API_URL = process.env.REACT_APP_API_URL;
export const MainPage = () => {
    const [cookies] = useCookies(["key"]);
    const [summaries, setSummaries] = useState([]);
    const [overAll, setOver] = useState("");
    const [name, setName] = useState("");
    const [scores, setScores] = useState([0, 0, 0, 0, 0, 0]);
    const [date, setDate] = useState("");
    const [report, setReport] = useState(null);
    const [error, setError] = useState("");
    const [retry, setRetry] = useState(0);
    const [needsSession, setNeedsSession] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const controller = new AbortController();
        const load = async () => {
            setError(""); setReport(null); setNeedsSession(false);
            try {
                const config = { ...headerConfig, signal: controller.signal };
                const result = await axios.post(`${API_URL}/selfAssesments`, { request: "report", key: cookies.key }, config);
                if (result.data.authentication === "session_error") {
                    setNeedsSession(true);
                    throw new Error("Your assessment session has expired. Please start a new assessment.");
                }
                if (result.data.result !== 1) throw new Error("Complete and save your assessment before opening its report.");
                const analysis = await axios.post(`${API_URL}/selfAssesments`, { request: "analyze", key: cookies.key }, config);
                if (analysis.data.result !== 1 || !analysis.data.report?.reportKey) throw new Error("Your report is unavailable. Please retry.");
                if (controller.signal.aborted) return;
                setName(result.data.name); setScores(result.data.PEARLIValues); setDate(result.data.timestamp);
                setSummaries(SUMMARY_FIELDS.map(field => analysis.data.message[field]));
                setOver(analysis.data.message.Generalsummary); setReport(analysis.data.report);
            } catch (failure) {
                if (!controller.signal.aborted) setError(failure.response ? failure.response.data?.message || "Your report is unavailable. Please retry." : failure.message || "Your report is unavailable. Please retry.");
            }
        };
        load();
        return () => controller.abort();
    }, [cookies.key, retry]);

    if (error) return <div role="alert"><p>{error}</p>{needsSession
        ? <button onClick={() => navigate("/")}>Start a new assessment</button>
        : <button onClick={() => setRetry(value => value+1)}>Retry report</button>}</div>;
    if (!report) return <p role="status">Preparing your personal PEARLI reflection…</p>;

    return (
        <AssessmentTemplate
            headerTitle="PEARLI Assessment Summary"
            headerSubtitle="Reflect on your well-being, one domain at a time"
            breadcrumbs={[
                { icon: faHouse, text: "Self Mindfulness" },
                { icon: faHouse, text: "PEARLI (General Life)" },
                { text: "Summary Report", active: true }
            ]}
            tags={[
                "Physical", "Emotional", "Relationship", "Acceptance", "Loving-Kindness", "Intellectual"
            ]}
            title={(name ? name + ", " : "") + "Here’s your PEARLI Assessment Summary"}
            subtitle={"A reflection of your well-being across six dimensions | " + date}
            onButtonClick={() => console.log("Start clicked!")}
            reportKey={report?.reportKey}
            scores={scores}
            clickButton={function (category) {
                const content = document.getElementById(category);
                const downIcon = document.getElementById(category + "d");

                if (!content) {
                    console.warn(`No content found for: ${category}`);
                    return;
                }

                if (content.style.display === "inline-block") {
                    content.style.display = "none";
                    if (downIcon) downIcon.style.display = "inline";
                } else {
                    content.style.display = "inline-block";
                    if (downIcon) downIcon.style.display = "none";
                }
            }}

            summaries={summaries}
            overAll={overAll}
        />
    );
};